import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import InstitutionIconsLinkOrAddAccountsTemplate from './InstitutionIconsTemplate';

const LinkOrAddAccountsTemplatePicker = ({
  resource,
  className,
  classes,
}) => {
  const Component = pick(resource, {}, InstitutionIconsLinkOrAddAccountsTemplate);
  return <Component resource={resource} classes={classes} className={className} />;
};

LinkOrAddAccountsTemplatePicker.defaultProps = {
  className: '',
  classes: {},
};

LinkOrAddAccountsTemplatePicker.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default LinkOrAddAccountsTemplatePicker;
